import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import { usePost } from '@src/store/posts/hooks/usePost';
import { type JSX, memo } from 'react';

interface PostTitleProps {
    postId: string;
    tokenName: string;
    className?: string;
    as?: keyof JSX.IntrinsicElements;
}

const PostTitle = (props: PostTitleProps) => {
    const { as = 'h1', postId, className = '' } = props;

    const post = usePost(postId);
    const title = post?.title;
    return (
        <Text data-ssr="post-title" enableMultiline={true} as={as} className={cn('font-bold line-clamp-2', className)}>
            {title}
        </Text>
    );
};

export default memo(PostTitle);
